import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Gate for the admin area.
//
// ⚠️ This is a UI convenience, not the security boundary. Roles come from
// /users/me, which resolves them the same way the API's own requireRoleAny does,
// so the two cannot disagree — but the enforcement that matters happens
// server-side on every /api/publishers call. Never move an admin capability into
// the client on the strength of this check.
//
// A non-admin is sent home rather than to /login: they are already signed in, so
// a login prompt would be a dead end.
const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user?.roles?.includes('admin')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
